import { AfterViewInit, Directive, Input, OnDestroy, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { ClarityIdentityField, ClarityService } from '../services/clarity.service';

@Directive({
  selector: '[talyClarityField]',
  standalone: false,
})
export class ClarityIdentityDirective implements AfterViewInit, OnDestroy {
  @Input('talyClarityField') field!: ClarityIdentityField;

  private ngControl = inject(NgControl, { optional: true, self: true });
  private clarityService = inject(ClarityService);
  private destroy$ = new Subject<void>();

  ngAfterViewInit(): void {
    const control = this.ngControl?.control;
    if (!control || !this.field) {
      return;
    }

    this.capture(control.value);

    control.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((value) => this.capture(value));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private capture(value: unknown): void {
    const control = this.ngControl?.control;
    if (control && control.invalid) {
      return;
    }

    this.clarityService.applyIdentity({ [this.field]: value as string });
  }
}
